import { createServerRunner } from '@aws-amplify/adapter-nextjs';
import { ResourcesConfig } from 'aws-amplify';

const config: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID ?? '',
      userPoolClientId: process.env.NEXT_PUBLIC_COGNITO_APP_CLIENT_ID ?? '',
      signUpVerificationMethod: 'code' as 'code' | 'link', // 'code' | 'link'

      loginWith: {
        oauth: {
          // providers: ['Google', 'Facebook'],
          domain: 'eva-digital-exp.auth.us-west-2.amazoncognito.com',
          scopes: [
            // 'phone',
            'email',
            // 'public_profile',
            // 'profile',
            'openid',
            // 'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: [process.env.AMPLIFY_REDIRECT_URL ?? 'https://evrealestate.netlify.app/'],
          redirectSignOut: [
            process.env.AMPLIFY_REDIRECT_URL ?? 'https://evrealestate.netlify.app/',
          ],
          responseType: 'code' as 'code' | 'token', // or 'token', note that REFRESH token will only be generated when the responseType is code
        },
      },
    },
  },
};

const { runWithAmplifyServerContext } = createServerRunner({
  config,
  runtimeOptions: {
    cookies: {
      sameSite: 'strict',
      maxAge: 60 * 60 * 24 * 7, // 7 days
    },
  },
});

export { config, runWithAmplifyServerContext };
